module.exports = __webpack_public_path__ + "static/hero_art_mobile-ad08dcc61596c0caba5e0432d97c7459.svg";